import { createRecursiveProxy } from './lib/createRecursiveProxy.js';

const qraftAPIClient = (services, callbacks, options)=>{
    return createRecursiveProxy(function getCallback(getPath, key) {
        if (getPath.length !== 2 || key !== 'schema') return; // todo::maybe return callback?
        const serviceOperation = getByPath(services, getPath);
        if (!isServiceOperation(serviceOperation)) throw new Error(`Service operation not found: ${getPath.join('.')}`);
        return serviceOperation.schema;
    }, function applyCallback(applyPath, args) {
        const { path, callbackName } = extractCallbackDetails(applyPath);
        if (!(callbackName in callbacks)) throw new Error(`Function ${callbackName} is not supported`);
        const serviceOperation = getByPath(services, path);
        if (!isServiceOperation(serviceOperation)) throw new Error(`Service operation not found: ${path.join('.')}`);
        return callbacks[callbackName](options, serviceOperation.schema, args);
    }, []);
};
/**
 * Extracts Callback details from the applyPath
 * @param applyPath
 */ function extractCallbackDetails(applyPath) {
    // <service>.<operation>()
    if (applyPath.length === 2) {
        return {
            path: applyPath,
            callbackName: 'operationInvokeFn'
        };
    } else {
        // <service>.<operation>.<method>()
        return {
            path: applyPath.slice(0, -1),
            // The last arg is for instance `.useMutation` or `.useQuery()`
            callbackName: applyPath[applyPath.length - 1]
        };
    }
}
function isServiceOperation(input) {
    return input !== null && typeof input === 'object' && 'schema' in input;
}
function getByPath(obj, path) {
    return path.reduce((acc, key)=>{
        if (acc && typeof acc === 'object' && key in acc) return acc[key];
    }, obj);
}

export { qraftAPIClient };
//# sourceMappingURL=qraftAPIClient.js.map
